const APPROVED_RUNTIME_TOKEN_HOSTS = new Set([
    'ics-portal.mosaic-dev.siemens-energy.cloud',
    'ics-portal.mosaic-qa.siemens-energy.cloud',
]);

declare global {
    interface Window {
        __E2E_GRAPHQL_AUTH_TOKEN__?: string;
        __LOCAL_AUTH_TOKEN__?: string;
    }
}

export function isRuntimeTokenHost(hostname: string): boolean {
    return APPROVED_RUNTIME_TOKEN_HOSTS.has(hostname);
}

export function getRuntimeAuthToken(): string | undefined {
    if (typeof window === 'undefined') {
        return undefined;
    }
    if (!isRuntimeTokenHost(window.location.hostname)) {
        return undefined;
    }

    const token = window.__E2E_GRAPHQL_AUTH_TOKEN__;
    if (token && token.trim().length > 0) {
        return token;
    }
    return undefined;
}
